export default __webpack_public_path__ + "static/media/underProducation.ad7e2f4b.png";